export default "__VITE_ASSET__d$1a8Sb2__"